import { createContext } from 'react';

// State holds quiz settings & mode
const State = createContext({});
export default State;
